import {CatalogoApiService} from './../../../service/api/catalogo.api';
import {GlobalService} from './../../../service/global.service';
import {Component, HostListener} from '@angular/core';
import {FormControl} from '@angular/forms';
import {Servico} from '../../../model/catalogo';
import {ModalService} from '../../../service/modal.service';
import {PesquisasFiltroApiService} from '../../../service/api/pesquisas-filtro.api';
import {TipoEstado} from '../../../model/constantes';
import {ConstantesApiService} from '../../../service/api/constantes.api';
import {DetalhamentoApiService} from './../../../service/api/detalhamento.api';
import {Router} from '@angular/router';
import {IMyDpOptions} from 'mydatepicker';
import {
    FiltroServico,
    FiltroAlteracaoEstado,
    FiltrosDeServico,
    ResultadoFiltroDetalhaServico,
    FiltroMetadata,
    ResultadoFiltroServico
} from './../../../model/filtros';
import {JQueryStatic} from 'jquery';

declare var $: JQueryStatic;

@Component({
    selector: 'servico',
    templateUrl: './servico.component.html',
    styleUrls: ['./servico.component.css', '../artefato.css']
})

export class ArtefatoServicoComponent {
    resultados: ResultadoFiltroServico = new ResultadoFiltroServico();
    estados: Array<TipoEstado> = new Array<TipoEstado>();

    //filtros
    codigo = new FormControl('', []);
    estado = new FormControl('0', []);
    alteracaoEstado = new FormControl('', []);
    versao = new FormControl('', []);
    descricao = new FormControl('', []);
    matricula = new FormControl('', []);
    nome = new FormControl('', []);
    dtInicio = new FormControl('', []);
    dtFim = new FormControl('', []);
    irpagina = new FormControl('', []);

    filtroNome: String = '';
    hoje: Date = new Date();

    //paginacao
    pagina: number = 1;

    //resultado filtro
    detalhesServico: ResultadoFiltroDetalhaServico = new ResultadoFiltroDetalhaServico();

    constructor(
        private modalService: ModalService,
        private router: Router,
        private constantesService: ConstantesApiService,
        public pesquisaService: PesquisasFiltroApiService,
        public catalogoService: CatalogoApiService,
        public globalService: GlobalService,
        public detalhamentoApiService: DetalhamentoApiService) {
    }

    @HostListener('window:keyup', ['$event'])
    keyEvent(event: KeyboardEvent) {
        if (event != null) {
            if (event.keyCode === 13) {
                this.filtrarServicos();
            }
        }
    }

    ngOnInit() {
        this.constantesService.buscaTipoEstado(0)
            .subscribe(estados => this.estados = estados as Array<TipoEstado>);
        this.filtrarServicos();
    }

    public myDatePickerOptions: IMyDpOptions = {
        // dateFormat: 'dd/mm/yyyy',
        dateFormat: 'yyyy-mm-dd',
        monthLabels: {
            1: 'Jan',
            2: 'Fev',
            3: 'Mar',
            4: 'Abr',
            5: 'Mai',
            6: 'Jun',
            7: 'Jul',
            8: 'Ago',
            9: 'Set',
            10: 'Out',
            11: 'Nov',
            12: 'Dez'
        },
        dayLabels: {su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab'},
        sunHighlight: true,
        satHighlight: true,
        editableDateField: true,
        todayBtnTxt: 'Hoje',
        firstDayOfWeek: 'su',
        maxYear: this.hoje.getFullYear(),
        openSelectorOnInputClick: true
    };

    detalharServico(codServico, versao) {
        this.detalhamentoApiService.detalhaServico(codServico, versao)
            .subscribe(response => {
                    this.detalhesServico = response;
                    $('#detalheModal').modal('show');
                },
                erro => {
                });
    }

    editarServico(codServico: number, versao: number) {
        this.router.navigate(['/cadastro-servico', codServico, versao]);
    }

    excluirServico(codServico: number, versao: number) {
        let msgSucesso = 'Serviço removido com sucesso.';
        let msgErro = 'Ocorreu um erro ao remover o serviço.';
        this.catalogoService.removeServico(codServico, versao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.filtrarServicos();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );
    }

    novoServico() {
        this.router.navigate(['/cadastro-servico']);
    }

    filtrarServicos() {
        this.globalService.loading = true;
        this.pesquisaService.mudarPagina(this.pagina);
        this.pesquisaService.filtraServicoPaginado(this.getFiltros())
            .subscribe(
                listaItens => {
                    this.resultados = listaItens as ResultadoFiltroServico;
                    this.globalService.loading = false;
                    // this.modalService.fecharPaginaModal()
                },
                erro => {
                    if (erro.status == 404) {
                        this.resultados.servicos = new Array<Servico>();
                    }
                    this.globalService.loading = false;
                    // this.modalService.fecharPaginaModal()
                }
            );
    }

    proximaPagina(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina++;
        this.filtrarServicos();
    }

    paginaAnterior(desabilitado: string) {
        if (desabilitado == 'true') {
            return false;
        }
        this.pagina--;
        this.filtrarServicos();
    }


    IrparaPargina() {

        if (this.irpagina.value != 0) {
            this.pagina = this.irpagina.value;
            this.filtrarServicos();
        }


    }

    getFiltros() {
        let filtros = new FiltrosDeServico();
        let filtroServico = new FiltroServico();
        let filtroAlteracaoEstado = new FiltroAlteracaoEstado();
        let filtroMetadata = new FiltroMetadata();

        filtroMetadata.pagina = this.pagina;
        filtroMetadata.porPagina = 10;

        // filtro servico
        if (this.codigo.value != '') {
            filtroServico.codigo = this.codigo.value;
        }
        if (this.versao.value != '') {
            filtroServico.versao = this.versao.value;
        }
        if (this.nome.value != '') {
            filtroServico.nome = this.nome.value;
        }
        if (this.estado.value != '' && this.estado.value != '0') {
            filtroServico.codTipoEstado = this.estado.value;
        }
        if (this.descricao.value != '') {
            filtroServico.descricao = this.descricao.value;
        }

        // filtro alteracao estado
        if (this.alteracaoEstado.value != '' && this.alteracaoEstado.value != '0') {
            filtroAlteracaoEstado.codTipoEstado = this.alteracaoEstado.value;
        }
        if (this.matricula.value != '') {
            filtroAlteracaoEstado.matricula = this.matricula.value;
        }
        if (this.dtInicio.value != '') {
            filtroAlteracaoEstado.dataInicial = this.dtInicio.value.formatted;
        }
        if (this.dtFim.value != '') {
            filtroAlteracaoEstado.dataFinal = this.dtFim.value.formatted;
        }

        filtros.filtroServico = filtroServico;
        filtros.filtroAlteracaoEstado = filtroAlteracaoEstado;
        filtros.metadata = filtroMetadata;

        return filtros;
    }


    alterarEstado(codigo, versao, tipoOperacao) {

        let msgSucesso = '';
        let msgErro = '';
        let msgAtualizacao = '';

        switch (tipoOperacao) {
            case 'despacha':
                msgSucesso = 'Serviço despachado com sucesso.';
                msgErro = 'Ocorreu um erro ao despachar o servico.';
                msgAtualizacao = 'Item despachado pelo sistema de Administração Web.';
                break;
            case 'aprova':
                msgSucesso = 'Serviço aprovado com sucesso.';
                msgErro = 'Ocorreu um erro ao aprovar o servico.';
                msgAtualizacao = 'Item aprovado pelo sistema de Administração Web.';
                break;
            case 'ativa':
                msgSucesso = 'Serviço ativado com sucesso.';
                msgErro = 'Ocorreu um erro ao ativar o servico.';
                msgAtualizacao = 'Item ativado pelo sistema de Administração Web.';
                break;
            case 'inativa':
                msgSucesso = 'Serviço inativado com sucesso.';
                msgErro = 'Ocorreu um erro ao inativar o servico.';
                msgAtualizacao = 'Item inativado pelo sistema de Administração Web.';
                break;
        }

        this.globalService.loading = true;
        this.catalogoService.alterarEstadoServico(codigo, versao, tipoOperacao, msgAtualizacao)
            .subscribe(
                response => {
                    this.globalService.loading = false;
                    this.modalService.exibirMensagem('Sucesso', msgSucesso, 'Fechar');
                    this.filtrarServicos();
                },
                erro => {
                    this.globalService.loading = false;
                    if (erro.status == 404 || erro.status == 500) {
                        this.modalService.exibirMensagem('Erro', msgErro, 'Fechar');
                    }
                    if (erro.status == 403) {
                        this.modalService.exibirMensagem('Erro', 'Você não possui permissão para efetuar a operação', 'Fechar');
                    }
                }
            );

    }

    getEstado(codigo: Number) {
        let estado = this.estados.find(x => x.codigo == codigo);
        if (estado != null) {
            return estado.descricao;
        }
        return '-';

    }


    formataData(dt): string {
        var data = new Date(dt);
        return data.toLocaleString();
    }


}



// WEBPACK FOOTER //
// ./src/app/artefato/servico/servico.component.ts